"use client"

import { usePostHog } from "@/lib/posthog/hooks"
import { BOOK_ANCHOR_ID } from "./constants"

type Props = {
  className?: string
  children: React.ReactNode
  location: string
  clickEvent: string
  pixelContentName?: string
  href?: string
}

declare global {
  interface Window {
    fbq?: (...args: unknown[]) => void
  }
}

export function CTAButton({ className, children, location, clickEvent, pixelContentName, href }: Props) {
  const { captureEvent } = usePostHog()

  function handleClick() {
    captureEvent(clickEvent, { location })
    if (pixelContentName && typeof window !== "undefined" && typeof window.fbq === "function") {
      window.fbq("track", "InitiateCheckout", { content_name: pixelContentName, location })
    }
  }

  return (
    <a href={href ?? `#${BOOK_ANCHOR_ID}`} onClick={handleClick} className={className}>
      {children}
    </a>
  )
}
